export type ErrorType =
  | 'SCHEMA_VALIDATION_ERROR'
  | 'INVALID_INPUT_ERROR'
  | 'AUTHORIZATION_ERROR'
  | 'SEARCH_NOT_FOUND_ERROR'
  | 'HTTP_ERROR'
  | 'REQUEST_UNREACHABLE_ERROR';

export class GlyTouCanError extends Error {
  public errorType: ErrorType;
  public url?: string;
  public query?: string;

  constructor({
    message,
    errorType,
    name,
    url,
    cause,
    stack,
    query,
  }: {
    message: string;
    errorType: ErrorType;
    name: string;
    cause?: unknown;
    stack?: string;
    url?: string;
    query?: string;
  }) {
    super();
    this.message = message;
    this.name = name;
    this.cause = cause;
    this.stack = stack;
    this.errorType = errorType;
    this.url = url;
    this.query = query;
  }
}
